import { styled } from 'styled-components';

import { ButtonOrLink } from 'components/ButtonOrLink/ButtonOrLink';
import { colors, spacing, transition } from 'theme/theme';

export const PostAListingPageButtonOrLink = styled(ButtonOrLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 60px;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 12px;
  padding: 8px 20px;
  color: ${colors.brandBlue};
  border: 1px solid ${colors.brandBlue};
  background-color: white;
  border-radius: 8px;
  transition: all ${transition};

  &:hover {
    color: white;
    background-color: ${colors.brandBlue};
  }
`;

export const PostAListingPageButtonText = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[16]};
`;
